/* import __COLOCATED_TEMPLATE__ from './contact-block.hbs'; */
import { classNames } from '@ember-decorators/component';
import { service } from '@ember/service';
import Super from './client-base';
import classic from 'ember-classic-decorator';
import styles from './contact-block.module.scss';

@classic
@classNames(styles.component)
export default class RequestInformationContactBlock extends Super {
  @service session;
}
